export default {
    data() {
        return {
            selectedFiles: [],
            isUploading: false,
            filesLimit: 5 * 1024 * 1024, //5mb
            showWarning: false,
            warningText: null,
            isSubmitDisabled: false,
            showLimits: true,
        }
    },

    computed: {
        errorFilesCount() {
            return this.selectedFiles.filter((file) => file.errorMessage).length
        },

        uploadedFilesCount() {
            return this.selectedFiles.filter((file) => file.isUploaded).length
        },
    },

    methods: {
        onFileSelected(e) {
            Array.from(e.target.files).forEach((file) => {
                this.selectedFiles.push({
                    file: file,
                    fileSize: file.size,
                    progress: 0,
                    isUploaded: false,
                })
            })
            this.checkForFileSizes()
        },

        checkForFileSizes() {
            if (this.calculateFilesSize() > this.filesLimit) {
                this.warningText = this.$t('pages.referrals.notes.add.warnings.size_limit')
                this.showWarning = true
                this.showLimits = true
                this.isSubmitDisabled = true
                return
            }
            this.showWarning = false
            this.isSubmitDisabled = false
        },

        calculateFilesSize() {
            return this.selectedFiles.reduce((sum, file) => (sum += file.file.size), 0)
        },

        convertFileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file.file)
                reader.onload = () =>
                    resolve({
                        ...file,
                        base64File: reader.result,
                    })
                reader.onerror = (error) => reject(error)
            })
        },

        removeAndValidateFiles(file) {
            this.selectedFiles = this.selectedFiles.filter((f) => f !== file)
            this.checkForFileSizes()
        },
    },
}
